import { firestore } from "@/plugins/firebase"
import {
    collection,
    query,
    onSnapshot,
} from "firebase/firestore"


export default {
    state: {
        allEinladungenArray: [],
    },
    mutations: {},
    actions: {
        async getAllEinladungen({ state }) {
            const datapath = "/Einladungen"
            const vOrderRef = collection(firestore, datapath)
            const vOrderq = query(vOrderRef)

            onSnapshot(vOrderq, (querySnapshot) => {
                state.allEinladungenArray = [];
                querySnapshot.forEach((doc) => {
                    const docdata = { ...{ id: doc.id }, ...doc.data() }

                    state.allEinladungenArray.push(docdata)
                })
            })
        },
    },

}

